import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { InfiniteScrollComponent } from './components/infinite-scroll/infinite-scroll.component';
import { InfiniteScrollItemDirective } from './directives/infinite-scroll-item/infinite-scroll-item.directive';

/** Component declaration and export array  */
const COMPONENTS = [InfiniteScrollComponent, InfiniteScrollItemDirective];

/**
 * Card module
 */
@NgModule({
  declarations: [COMPONENTS],
  imports: [CommonModule],
  exports: [COMPONENTS],
})
export class InfiniteScrollModule {}
